import DayPlanAdvice from './DayPlanAdvice';
import { useTranslator, useAppContext } from '@front-activerse/common-components';

const DietetiansAdvice = ({ advices }) => {
  const {
    images: { bulb },
  } = useAppContext();

  const { t } = useTranslator();

  return (
    <div className="chef-advice-container">
      <div className="smart-tip">
        <p className="semi-bold text-text-main-color">
          <img src={bulb} alt="" style={{ width: '24px' }} className="me-2" />
          {t('app.mealDetails.dieticianNotes.title')}
        </p>

        {advices.map((advice) => (
          <DayPlanAdvice key={advice.title} advice={advice} />
        ))}
      </div>
    </div>
  );
};

export default DietetiansAdvice;
